/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".spinner-overlay[_ngcontent-%COMP%]{position:fixed;width:100%;height:100%;top:0;left:0;background-color:rgba(255,255,255,.7);z-index:9999}.spinner-overlay[_ngcontent-%COMP%]:not(.cover-header){top:84px}.loader-spinner[_ngcontent-%COMP%]{position:fixed;left:50%;top:50%;transform:translate(-50%,-50%)}  .loader-spinner .mat-progress-spinner circle{stroke:#4bb166}"];
export { styles as styles };
